import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export type TGetCrudParams = {
  appId: string
  dropdown: string
  relation?: string
  cacheKey?: string
}

class OnboardingDropdownsApi {
  public getCrud({ appId, dropdown, relation, cacheKey }: TGetCrudParams) {
    const crud = CrudStore.get(CrudStoreItemOnboarding.OnboardingDropdowns, cacheKey)
    const filters = [
      {
        field: 'AppId',
        operator: Operator.EQUAL,
        value: appId,
      },
      {
        field: 'DropdownKey',
        operator: Operator.EQUAL,
        value: dropdown,
      },
    ]

    if (relation) {
      filters.push({
        field: 'Relation',
        operator: Operator.EQUAL,
        value: relation,
      })
    }
    crud.setDefaultFilter({
      logic: Logic.AND,
      filters,
    })

    return crud
  }
}

export const onboardingDropdownsApi = new OnboardingDropdownsApi()
